import { CheckRounded } from '@mui/icons-material';
import { Box, Checkbox, Typography } from '@mui/material';
import { humanizeName } from '../../utils';
import { MedicationEntry } from '.';

const iconStyle = {
  width: 40,
  height: 40,
  color: 'common.white',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
};

const Dosage = ({
  reminder,
  handleCheckBoxChange,
}: {
  reminder: MedicationEntry;
  handleCheckBoxChange: (event: { target: { name: string | number } }) => void;
}) => {
  return (
    <Box sx={{ py: 1, display: 'flex', alignItems: 'center' }}>
      <Typography variant="subtitle2">{humanizeName(reminder.dose)}</Typography>
      <Checkbox
        name={reminder?.dose}
        checked={Boolean(reminder.taken_on)}
        icon={
          <Box
            sx={{
              ...iconStyle,
              bgcolor: '#FE4D0133',
            }}
          />
        }
        checkedIcon={
          <Box
            sx={{
              ...iconStyle,
              bgcolor: 'secondary.main',
            }}
          >
            <CheckRounded />
          </Box>
        }
        onChange={handleCheckBoxChange}
        sx={{ ml: 'auto' }}
      />
    </Box>
  );
};

export default Dosage;
